// src/pages/Landing/LandingMobile.jsx
// Si ton composant desktop est déjà très responsive, on peut simplement le réutiliser :
import LandingDesktop from "./LandingDesktop";
export default function LandingMobile() {
  return <LandingDesktop />;
}
